import { ActionReducer, ActionReducerMap, MetaReducer } from "@ngrx/store";
import { ShoppingReducer, ShoppingState } from "../reducers/shopping-reducer";
import { localStorageSync } from 'ngrx-store-localstorage';



export const rootReducer = {};

export interface AppState {
    readonly shopping: ShoppingState;
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return localStorageSync({
      keys: ['shopping'],
      rehydrate: true
    })(reducer);
  }

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

export const reducers: ActionReducerMap<AppState, any> = {
    shopping: ShoppingReducer
};